import { api } from "./api";
import { AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export default class PowerBiNode {


  getEmpresaReports = async (body: AuthBodyType, empresaId: string) => {
    try {
      const data: AxiosResponse = await api.post("/powerBi/getEmpresaReports", {
        ...body,
        empresaId,
      });
      return data.data;
    } catch (error) {
      console.error("Erro ao buscar relatórios da empresa:", error);
      throw error;
    }
  };

  getEmbedToken = async (body: AuthBodyType, identityUser: string, workspaceId: string, reportId: string, empresaId: string) => {
    const data: AxiosResponse = await api.post("/powerBi/getEmbedToken", {
      ...body,
      identityUser,
      workspaceId,
      reportId,
      empresaId,
    });
    return data.data;
  };
}

// getEmbedToken
// "identityUser": string,
//   "workspaceId": string,
//   "reportId": string
